import { Component } from '@angular/core';
import { AgrExtendedNotificationModule } from '@next/core-lib/components';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
  imports: [AgrExtendedNotificationModule, AgrI18nSharedModule],
})
export class MaintenanceComponent {}
